import React from "react";
import PublicHeader from "./PublicHeader";
import Footer from "./Footer";

export default function PublicPageLayout({ eyebrow, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-background text-white overflow-x-hidden">
      <PublicHeader />

      <section className="max-w-3xl mx-auto px-5 pt-20 pb-8 md:pt-28">
        {eyebrow && (
          <span className="inline-block text-xs tracking-wider uppercase font-semibold text-primary border border-primary/30 rounded-full px-3 py-1 mb-6">
            {eyebrow}
          </span>
        )}
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-extrabold leading-[1.05]">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-lg text-zinc-300 leading-relaxed max-w-xl">{subtitle}</p>}
      </section>

      <section className="max-w-3xl mx-auto px-5 pb-28">
        <div
          className="text-zinc-300 leading-relaxed
            [&_h2]:font-heading [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:first:mt-0
            [&_p]:mb-4
            [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_ul]:mb-4
            [&_li]:text-zinc-300
            [&_p_a]:text-primary [&_p_a]:hover:underline
            [&_li_a]:text-primary [&_li_a]:hover:underline"
        >
          {children}
        </div>
      </section>

      <Footer />
    </div>
  );
}
